
import {
  getEvents,
  computeUniqueVisitors,
  computeConversionRate,
  computeUTMBreakdown,
  computeDeviceBreakdown,
  computeDailyTrend,
  DBRow,
} from './analytics';
import { validateApiKeyFromDB } from './apiKeys';

export interface AnalyticsAPIResponse {
  visitors: { unique: number; pageviews: number };
  conversions: { clicks: number; rate: number };
  utm_breakdown: Array<{ campaign: string; source: string; medium: string; visits: number; conversions: number; rate: number }>;
  daily_trend: Array<{ date: string; visitors: number; conversions: number }>;
  device_breakdown: {
    desktop: { count: number; percentage: number };
    mobile:  { count: number; percentage: number };
    tablet:  { count: number; percentage: number };
  };
}

export async function validateAPIKey(key: string | null): Promise<boolean> {
  if (!key) return false;
  return validateApiKeyFromDB(key);
}

export async function getAnalyticsData(
  startDate?: string,
  endDate?: string
): Promise<AnalyticsAPIResponse> {
  let startTs: number | undefined;
  let endTs: number | undefined;

  if (startDate) startTs = new Date(startDate).getTime();
  if (endDate)   endTs   = new Date(endDate).setHours(23, 59, 59, 999);

  const rows: DBRow[] = await getEvents(startTs, endTs);

  const pageviews      = rows.filter(r => r.type === 'page_view').length;
  const clicks         = rows.filter(r => r.type === 'affiliate_click').length;
  const uniqueVisitors = computeUniqueVisitors(rows);
  const conversionRate = computeConversionRate(rows);

  return {
    visitors:         { unique: uniqueVisitors, pageviews },
    conversions:      { clicks, rate: conversionRate },
    utm_breakdown:    computeUTMBreakdown(rows),
    daily_trend:      computeDailyTrend(rows),
    device_breakdown: computeDeviceBreakdown(rows),
  };
}
